import {CSSProperties, ReactNode} from "react";

export type Padding = string | number

export type ContainerProps = {
    padding?: Padding,
    children?: ReactNode,
    style?: CSSProperties,
    fullHeight?: boolean
    className?: string
    centerItems?: boolean
}

const paddingStyle = (padding: Padding) => {
    if (typeof padding === 'number') {
        return `${padding}px`
    }
    return padding
}

const addPaddingToStyle = (style?: CSSProperties, padding?: Padding) => {
    const _style = style ?? {}
    if (padding) {
        _style.padding = paddingStyle(padding)
    }
    return _style
}

const calculateContainerStyles = (style?: CSSProperties, padding?: Padding, fullHeight?: boolean, centerItems?:boolean): CSSProperties => {
    const _style = addPaddingToStyle(style, padding)
    if (fullHeight) {
        _style.height = "100%"
    }
    if(centerItems) {
        _style.display = "flex"
        _style.justifyContent = "center"
        _style.alignItems = "center"
    }
    return _style
}

export const Container = ({ padding, children, style, fullHeight=false, className,centerItems }: ContainerProps) => (
    <div className={className} style={calculateContainerStyles(style,padding,fullHeight,centerItems)}>
        { children }
    </div>
)
